import React from "react";
import "./upcomingTask.css";
import { ReactComponent as Dot } from "../../assets/images/more.svg";

const UpcomingTask = () => {
  return (
    <div className="upcoming_task">
      <div className="upcoming_task_content">
        <h2>Upcoming Task</h2>
        <ul>
          <li>
            <h6>
              July 01, 2022{" "}
              <span>
                <Dot />
              </span>{" "}
            </h6>
            <h4>BBQ Restaurant Landing Page</h4>
            <p>Flat Design</p>
          </li>
          <li>
            <h6>
              July 01, 2022{" "}
              <span>
                <Dot />
              </span>{" "}
            </h6>
            <h4>Live Class</h4>
            <p>Flat Design</p>
          </li>
          <li>
            <h6>
              July 01, 2022{" "}
              <span>
                <Dot />
              </span>{" "}
            </h6>
            <h4>Meeting with students</h4>
            <p>Flat Design</p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UpcomingTask;
